import { useMemo } from 'react';

const useSunWestSuccessYears = () => {
  const years = useMemo(() => {
    const foundedDate = new Date('1980-08-12');
    const todayDate = new Date();
    const yearDiff = todayDate.getFullYear() - foundedDate.getFullYear();
    const isDate2BeforeBirthday =
      todayDate.getMonth() < foundedDate.getMonth() ||
      (todayDate.getMonth() === foundedDate.getMonth() &&
        todayDate.getDate() < foundedDate.getDate());

    return isDate2BeforeBirthday ? yearDiff - 1 : yearDiff;
  }, []); // The useMemo hook will memoize the value and recalculate only if the dependencies change

  return years;
};

export default useSunWestSuccessYears;
